// Configure Amplify FIRST — this import has a side effect that calls Amplify.configure().
// It must be the first import so the Amplify singleton is configured before
// any auth module reads from it.
import "./amplify-config";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./styles/global.css";
import "./components/shared/shared.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
